<template>
    <el-dialog title="上传煤种数据" :visible="visible" :show="show" width="50%"  @close="close" :close-on-click-modal="false" custom-class="module-dialog">
        <el-form class="detail-form-content" ref="ruleForm" :model="ruleForm" label-width="140px">
            <el-form-item label="上传文件">
                <excel-file-upload ref="upload" :action="uploadIp" :on-success="handleSucessIp" accept=".xlsx,xls" :multipart="true">
                    <el-button type="primary" size="medium" icon="el-icon-bottom-right">导入excel数据</el-button>
                </excel-file-upload>
                <a type="primary" size="medium" icon="el-icon-top-right" style="margin-top:5%" v-if="orgType=='1'" :href="url+'file/download?fileName=总部煤炭模版.xlsx'">导出excel模板</a>
                <a type="primary" size="medium" icon="el-icon-top-right" style="margin-top:5%" v-if="orgType=='2'" :href="url+'file/download?fileName=地级市煤炭模版.xlsx'">导出excel模板</a>
                <a type="primary" size="medium" icon="el-icon-top-right" style="margin-top:5%" v-if="orgType=='3'" :href="url+'file/download?fileName=站点煤炭模版.xlsx'">导出excel模板</a>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>
<script>
    import base from '../../../utils/base'
    export default{
        name:'cocalImport',
        props:{
            show: {
                type: Boolean,
                default: false
            },
            rowData: {
                type: Object,
                default: function(){
                    return {};
                },
            },
        },
        watch:{
            show(){
                this.visible = this.show;
                if(this.show){
                    window.vm = this;
                    this.orgType = this.$storage.get("orgType");
                }
            },
        },
        data(){
            return{
                uploadIp:"/cocalTemplateOwner/importCocalData",
                visible:false,
                ruleForm:{ },
                url:base.get().url,
                orgType:'',
            }
        },
        methods:{
            close(){
                this.$refs['ruleForm'].resetFields();
                this.$emit("listenToChildEvent",false);
            },
            handleSucessIp(response){
            },
        }
    }
</script>
<style lang="scss">
    .module-dialog .el-dialog__header {
        background: linear-gradient(135deg, var(--publicMainColor) 0%, #2b5797 100%);
        padding: 16px 20px;
        border-radius: 4px 4px 0 0;
    }
    .module-dialog .el-dialog__title {
        color: #fff;
        font-size: 16px;
        font-weight: 600;
    }
    .module-dialog .el-dialog__headerbtn .el-dialog__close {
        color: rgba(255, 255, 255, 0.8);
    }
    .module-dialog .el-dialog__headerbtn .el-dialog__close:hover {
        color: #fff;
    }
    .detail-form-content .el-form-item__label {
        font-weight: 600;
        color: #303133;
    }
</style>